module.exports = __webpack_public_path__ + "static/media/drag_image_ru.18b59dda.jpg";